export default "__VITE_ASSET__7c5eafd9__"